import React, { useEffect, useState } from "react";
import {
  EmployeeScheduleModel,
  EnumAlertDialogType,
} from "../Managers/dataStructures";
import {
  fetchEmployeeSchedule,
  sendJoinRequestToTeamLead,
  timeout,
} from "../Managers/wepApiManager";
import { getCurrentUser } from "../Managers/profileManager";
import {
  ActivityIndicator,
  NegativeToast,
  PositiveToast,
} from "../Managers/utilityComponents";
import { serverDateStringToRegularDateString } from "../Managers/utilityFunctions";
import { getLanguage } from "../Managers/dataProvider";

export default function EmployeeSchedule() {
  const isEnglish = getLanguage();
  const [team_lead, setTeamLead] = useState<string>();
  const [array_schedules, setArraySchedule] = React.useState<
    EmployeeScheduleModel[]
  >([]);
  const [isJoiningRequest, setIsJoiningRequest] = useState<boolean>(false);
  const [joinRequestToast, setJoinRequestToast] = useState<EnumAlertDialogType>(
    EnumAlertDialogType.NEUTRAL
  );
  const [joinRequestMessage, setjoinRequestMessage] = useState<string>("");
  const [isHUD, setIsHud] = React.useState<boolean>(false);

  useEffect(() => {
    setIsHud(true);
    fetchEmployeeSchedule(
      getCurrentUser().user_id,
      (array_schedules: EmployeeScheduleModel[]) => {
        setIsHud(false);
        setArraySchedule(array_schedules);
      }
    );
  }, []);

  function onTeamLeadChange(value: string) {
    setTeamLead(value);
  }

  function sendRequest() {
    if (team_lead !== undefined) {
      setIsJoiningRequest(true);
      sendJoinRequestToTeamLead(
        team_lead,
        getCurrentUser().user_id,
        (isSuccess: boolean, message: string) => {
          setIsJoiningRequest(false);
          if (isSuccess) {
            setTeamLead(undefined);
          } else {
            setjoinRequestMessage(message);
          }
          showJoinToast(isSuccess, () => {});
        }
      );
    }
  }
  async function showJoinToast(isPositive: boolean, callback: () => void) {
    if (isPositive) {
      setJoinRequestToast(EnumAlertDialogType.POSITIVE);
    } else {
      setJoinRequestToast(EnumAlertDialogType.NEGATIVE);
    }

    await timeout(2000);
    setJoinRequestToast(EnumAlertDialogType.NEUTRAL);
    callback();
  }

  return (
    <div className="px-4 sm:px-6 lg:px-8">
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            {isEnglish ? "My Schdule" : "Mein Arbeitsplan"}
          </h1>
          <p className="mt-2 text-sm text-gray-700">
            {isEnglish
              ? "Your schedule for upcoming days."
              : "Der Arbeitsplan für die kommenden Tage"}
          </p>
        </div>
        <div className="mt-4 sm:ml-16 sm:mt-0 sm:flex-none"></div>
      </div>
      <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
        <div className="sm:col-span-3">
          <label
            htmlFor="temporary-branch-label"
            className="block text-sm font-medium leading-6 text-gray-900"
          >
            Temporary Branch
          </label>

          {TemporaryBranch(onTeamLeadChange, sendRequest, isJoiningRequest)}
          <div className="mt-2">
            {joinRequestToast === EnumAlertDialogType.NEUTRAL
              ? null
              : joinRequestToast === EnumAlertDialogType.POSITIVE
              ? PositiveToast("Request sent")
              : NegativeToast(joinRequestMessage)}
          </div>
        </div>
      </div>
      {isHUD === true ? (
        <div className="mt-5 flex items-center justify-center">
          {ActivityIndicator(1)}
        </div>
      ) : (
        <div>
          <div className="-mx-4 mt-10 ring-1 ring-gray-300 sm:mx-0 sm:rounded-lg">
            <table className="min-w-full divide-y divide-gray-300">
              <thead>
                <tr>
                  <th
                    scope="col"
                    className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                  >
                    {isEnglish ? "Date" : "Datum"}
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                  >
                    {isEnglish ? "Branch" : "Filiale"}
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                  >
                    {isEnglish ? "Timings" : "Arbeitszeit"}
                  </th>
                  <th
                    scope="col"
                    className="hidden px-3 py-3.5 text-left text-sm font-semibold text-gray-900 lg:table-cell"
                  >
                    {isEnglish ? "Shift" : "Schicht"}
                  </th>
                  <th
                    scope="col"
                    className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                  >
                    {isEnglish ? "Team Lead" : "Teamleiter"}
                  </th>
                </tr>
              </thead>

              <tbody>
                {array_schedules.map((schedule_item, index) =>
                  CellSchedule(schedule_item, index)
                )}
              </tbody>
            </table>
          </div>
          {array_schedules.length === 0 ? (
            <div className="mt-5 mb-5 item-center justify-center text-center w-full  text-gray-500 ">
              {isEnglish
                ? "No Schedule Exists"
                : "Keine geplanten Schichten vorhanden"}
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}

function CellSchedule(schedule: EmployeeScheduleModel, planIdx: number) {
  function classNames(...classes: any[]) {
    return classes.filter(Boolean).join(" ");
  }

  console.log("schedule date=" + schedule.plan_date);
  return (
    <tr key={planIdx}>
      <td
        className={classNames(
          planIdx === 0 ? "" : "border-t border-transparent",
          "relative py-4 pl-4 pr-3 text-sm sm:pl-6"
        )}
      >
        <div className="font-medium text-gray-900">
          {serverDateStringToRegularDateString(schedule.plan_date)}
        </div>
        <div className="mt-1 flex flex-col text-gray-500 sm:block lg:hidden">
          <span>
            {schedule.employee_start_time} / {schedule.employee_end_time}
          </span>
          <span className="hidden sm:inline">·</span>
          <span></span>
        </div>
        {planIdx !== 0 ? (
          <div className="absolute -top-px left-6 right-0 h-px bg-gray-200" />
        ) : null}
      </td>
      <td
        className={classNames(
          planIdx === 0 ? "" : "border-t border-gray-200",
          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
        )}
      >
        <div>{schedule.branch_name}</div>
        <div>{schedule.branch_address}</div>
      </td>
      <td
        className={classNames(
          planIdx === 0 ? "" : "border-t border-gray-200",
          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
        )}
      >
        <div>{schedule.employee_start_time}</div>
        <div>{schedule.employee_end_time}</div>
      </td>
      <td
        className={classNames(
          planIdx === 0 ? "" : "border-t border-gray-200",
          "hidden px-3 py-3.5 text-sm text-gray-500 lg:table-cell"
        )}
      >
        {schedule.shift_name}
      </td>
      <td
        className={classNames(
          planIdx === 0 ? "" : "border-t border-gray-200",
          "px-3 py-3.5 text-sm text-gray-500"
        )}
      >
        <div className="sm:hidden">{schedule.team_lead_email}</div>
        <div className="hidden sm:block">{schedule.team_lead_email}</div>
      </td>
    </tr>
  );
}

function TemporaryBranch(
  onTeamLeadChange: (team_lead_email: string) => void,
  onSendRequest: () => void,
  isActivity: boolean
) {
  const isEnglish = getLanguage();

  function sendRequest() {
    onSendRequest();
  }
  function onTLChange(value: string) {
    onTeamLeadChange(value);
  }
  return (
    <div className="mt-2 flex flex-row">
      <label
        htmlFor="temp-branch"
        className="block text-sm font-medium leading-6 text-gray-900"
      >
        {/* {value_ !== null ? value_ : "Not Selected"} */}
      </label>

      <label
        htmlFor="temp-branch"
        className="block text-sm font-medium pl pr-2 leading-6 text-gray-900"
      >
        {isEnglish ? "Team Lead ID" : "ID/E-Mail-Adresse des Teamleiters"}
      </label>
      <input
        type="text"
        name="street-address"
        id="tb-street-address"
        onChange={(x) => onTLChange(x.currentTarget.value)}
        autoComplete="street-address"
        className="block rounded-md pl-1 h-max border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-4"
      />
      <td className="whitespace-nowrap pl-3 pr-4 text-right text-sm font-medium sm:pr-3">
        <div className="flex flex-row">
          <a
            onClick={sendRequest}
            href="#SendRquest"
            className="text-indigo-600 hover:text-indigo-900"
          >
            {isEnglish ? "Send Request" : "Anfrage senden"}
            <span className="sr-only">{", Send Request"}</span>
          </a>

          {isActivity ? (
            <div className="pl-5"> {ActivityIndicator(1)} </div>
          ) : null}
        </div>
      </td>
    </div>
  );
}
